import React from "react";
import { Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Link,
  CircularProgress,
  Snackbar,
  Box,
  Button,
} from "@material-ui/core";
import {
  faTrashAlt,
  faEdit,
  faDownload,
  faCloud,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CloudUpload } from "@material-ui/icons";
import { generateFileUrl, uploadFile } from '../../../Messeges/api'
import { shallowEqual, useSelector } from "react-redux";
import { AddFile, GetFile, DeleteFile } from "../apis";
import moment from "moment";
import EditFileName from "./EditFilePopup";

const initialImageBlob = {
  apiUrl: "",
  type: "",
  name: "",
}

export function UploadDocument(props) {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [files, setFiles] = React.useState([]);
  const [images, setImages] = React.useState([])
  const [imageBlob, setImageBlob] = React.useState({ ...initialImageBlob });
  const s3Url = "https://chat-attachements.s3.amazonaws.com";

  const [showEdit, setShowEditDialog] = React.useState(false);
  const [editType, setEditType] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState()

  const onDrop = React.useCallback(async (acceptedFiles) => {
    if (acceptedFiles[0].size > (6 * 1000 * 1000)) {
      alert("File Size is too large")
      return
    }

    setFiles([...acceptedFiles]);
    let name = `${new Date().valueOf()}.${acceptedFiles[0].name.split(".")[1]}`;
    let originalName = acceptedFiles[0].name
    let type = acceptedFiles[0].type;
    let url = await generateFileUrl({ name, mime: type });
    let newUrl = await uploadFile(url, acceptedFiles[0]);
    let data = {
      name: originalName,
      url: `${s3Url}/${name}`,
      type,
      jobSeekerId: props.user,
      coachId: user.id,
      userType: "COACH",
    }

    const addData = await AddFile(data)
    FetchImages()

    // setImageBlob({
    //   ...imageBlob,
    //   apiUrl: url,
    //   name: name,
    //   type,
    // });
    console.log("url:-=-=", url)
  }, []);

  const FetchImages = async () => {
    const getData = await GetFile({ jobSeekerId: props.user, userType: "COACH" })
    setImages([...getData])
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  const onChangeFiles = (evt) => {
    console.log("evnt file:-=-=-=", evt.target)
  }

  React.useEffect(() => {
    FetchImages()
  }, [])

  const deleteFile = async (id) => {
    let del = await DeleteFile(id)
    FetchImages()
  }

  const openditDailog = (d, name) => {
    setShowEditDialog(true)
    setSelectedFile(d)
    setEditType(name)
  }

  const closeditDailog = () => {
    setShowEditDialog(false)
    setSelectedFile(undefined)
    setEditType('')
  }

  return (
    <Card>
      <Card.Body>
        <Card.Title
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <CloudUpload style={{ fontSize: 75 }} />
            <h1
              style={{
                marginLeft: 20,
              }}
            >
              {" "}
              Upload Document
            </h1>
          </p>
          <div>
            <div {...getRootProps()}>
              <input {...getInputProps({ multiple: false })} />
              <label htmlFor="contained-button-file">
                <Button variant="contained" color="secondary" component="span">
                  <CloudUpload style={{ fontSize: 17, marginRight: 10 }} />
                  Upload
                </Button>
              </label>
            </div>
            {/* <input
              accept="image/*"
              style={{
                display: "none",
              }}
              id="contained-button-file"
              multiple
              type="file"
              onChange={onChangeFiles}
            /> */}
            {/* <label htmlFor="contained-button-file">
              <Button variant="contained" color="secondary" component="span">
                <CloudUpload style={{ fontSize: 17, marginRight: 10 }} />
                Upload
              </Button>
            </label> */}
          </div>
        </Card.Title>
        <TableContainer>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="h6" color="initial">
                    My Documents
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="h6" color="initial">
                    Type
                  </Typography>
                </TableCell>
                <TableCell style={{ minWidth: "120px" }}>
                  <Typography align="center" variant="h6" color="initial">
                    Date
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography align="center" variant="h6" color="initial">
                    {" "}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {images && images.length > 0 && images.map((i) => {
                return (
                  <TableRow key={i._id}>
                    <TableCell>
                      <Typography variant="body1" color="initial">
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="mx-3"
                          style={{
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => openditDailog(i, 'name')}
                        />{" "}
                        {i.name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body1" color="initial">
                        <FontAwesomeIcon
                          icon={faEdit}
                          className="mx-3"
                          style={{
                            fontSize: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => openditDailog(i, 'type')}
                        />{" "}
                        {i.type}
                      </Typography>
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {moment(i.createdAt).format('MMMM Do YYYY, h:mm:ss a')}
                    </TableCell>
                    <TableCell align="center">
                      <FontAwesomeIcon
                        icon={faDownload}
                        color="#90ee90"
                        className="mx-3"
                        style={{
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => window.open(i.url, "_blank")}
                      />
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        color="red"
                        className="mx-3"
                        style={{
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteFile(i._id)}
                      />
                    </TableCell>
                  </TableRow>
                )
              })}

            </TableBody>
          </Table>
        </TableContainer>
      </Card.Body>
      {/* <Snackbar
          open={open}
          autoHideDuration={5000}
          color="danger"
          onClose={handleSnackBarClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <Alert
            onClose={handleSnackBarClose}
            style={{ fontSize: "16px" }}
            severity="success"
          >
            {"Resume deleted successfully"}
          </Alert>
        </Snackbar> */}
      {showEdit && <EditFileName open={showEdit} onClose={closeditDailog} selectedFile={selectedFile} fetch={FetchImages} type={editType} />}
    </Card>
  );
}
